"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = void 0;
var spacing = exports.spacing = {
  space025: '2px',
  /**
   * @deprecated - use space05
   */
  space5: '4px',
  space05: '4px',
  space10: '8px',
  space15: '12px',
  space20: '16px',
  space30: '24px',
  space40: '32px',
  space50: '40px',
  space60: '48px',
  space90: '72px',
  space70: '56px',
  space80: '64px',
  space100: '80px',
  space130: '104px',
  space160: '128px',
  '-space025': '-2px',
  '-space05': '-4px',
  '-space10': '-8px',
  '-space15': '-12px',
  '-space20': '-16px',
  '-space60': '-48px',
  '-space70': '-56px',
  '-space50': '-40px',
  '-space40': '-32px',
  '-space30': '-24px',
  '-space80': '-64px',
  '-space90': '-72px',
  '-space100': '-80px',
  '-space130': '-104px',
  '-space160': '-128px',
  /**
   * @deprecated - use space5
   */
  spacingXXS: '4px',
  /**
   * @deprecated - use space10
   */
  spacingXS: '8px',
  /**
   * @deprecated - use space15
   */
  spacing2XS: '12px',
  /**
   * @deprecated - use space20
   */
  spacingS: '16px',
  /**
   * @deprecated - use space30
   */
  spacingM: '24px',
  /**
   * @deprecated - use space40
   */
  spacingML: '32px',
  /**
   * @deprecated - use space50
   */
  spacingL: '40px',
  /**
   * @deprecated - use space60
   */
  spacingXL: '48px',
  /**
   * @deprecated - use space80
   */
  spacing2XL: '64px',
  /**
   * @deprecated - use space160
   */
  spacing3XL: '128px'
};